export const staticData = {
  Roulette: [
    201, 203, 204, 205, 206, 208, 210, 213, 221, 222, 223, 224, 225, 226, 227, 229, 230, 233, 234, 237, 240, 262, 211,
  ],
  "Black Jack": [
    [301, 302, 303, 304, 305, 321, 322, 323],
    [
      511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 535, 536, 537,
      538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 551, 552, 553, 554, 555, 556, 557, 558, 559, 560,
      561, 562, 563, 564, 565, 566, 567, 568, 569, 570, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602,
      603, 604, 605, 606, 607, 608, 609, 612, 613, 614, 615, 616, 617, 618, 619, 620, 621, 622, 623, 624, 625, 626, 641,
      642, 643, 644, 645, 646, 647, 658, 659, 660, 661, 662, 663, 664, 671, 672, 673, 674, 675, 676, 677, 678, 681, 682,
      683, 684, 685, 686, 687, 688,
    ],
    [721, 722, 723, 724, 725, 730, 731, 747, 748, 749, 750, 751],
    [
      3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3024,
      3025, 3046, 3047, 3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055,
    ],
  ],
  Baccarat: [
    401, 402, 403, 404, 405, 411, 412, 413, 414, 415, 421, 422, 424, 425, 426, 427, 428, 430, 431, 432, 433, 434, 435,
    436, 438, 439, 441, 442, 449, 450, 451, 454, 455, 456, 457, 458, 459, 460, 476, 479, 481, 482, 488, 489, 490, 491,
    1401,
  ],
  Sicbo: [701, 711],
  // Megawheel: [801],
  OneBJ: [901, 902, 904],
  "Dragon Tiger": [1001],
  CONTEST: [801, 1101, 1301, 1701, 1501, 4001, 522],
  ABH: [1024],
  // SWB: [1101],
  // BOB: [1401],
  // VB25: [1501],
  // TreasureIsland: [1701],
  Football: [4001],
  Chroma: ["211a1"],
};
